import * as React from "react"
import { router } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import { Select } from "@/components/ui/select"

export function BackfillCard({ lastRun }: { readonly lastRun: Record<string, unknown> | null }) {
  const [daysBack, setDaysBack] = React.useState("14")

  const submit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    router.post("/settings/backfill", { days_back: daysBack }, { preserveScroll: true })
  }

  return (
    <section className="rounded-lg border border-hairline bg-page p-6">
      <h2>Refresh from SmartLead</h2>
      <p className="mt-2">Enqueue a read-only backfill for recent replied leads.</p>
      <form onSubmit={submit} className="mt-5 flex flex-wrap items-end gap-3">
        <label className="space-y-2">
          Window
          <Select value={daysBack} onChange={(event) => setDaysBack(event.target.value)}>
            <option value="1">1 day</option>
            <option value="2">2 days</option>
            <option value="7">7 days</option>
            <option value="14">14 days</option>
            <option value="30">30 days</option>
            <option value="0">Full</option>
          </Select>
        </label>
        <Button type="submit">Queue backfill</Button>
      </form>
      {lastRun && (
        <dl className="mt-5 grid gap-4 sm:grid-cols-3">
          <SummaryItem label="Campaigns" value={String(lastRun.campaigns_visited ?? 0)} />
          <SummaryItem label="New threads" value={String(lastRun.ingested_new_threads ?? 0)} />
          <SummaryItem label="Duplicates" value={String(lastRun.duplicate_messages ?? 0)} />
        </dl>
      )}
    </section>
  )
}

function SummaryItem({
  label,
  value,
}: {
  readonly label: string
  readonly value: string
}) {
  return (
    <div className="space-y-2">
      <dt className="text-sm text-ink-muted">{label}</dt>
      <dd className="text-ink-display">{value}</dd>
    </div>
  )
}
